export function fetchRequestNewsView(title,UUID) {

    const myHeaders = new Headers();

    const raw = JSON.stringify({
        "article_title": title,
        "uuid": UUID,
    });

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
    };

    return fetch(`https://feedback.sespel.su/article/view`, requestOptions)
        .then((response) => response.json())
        .then((result) => result)
        .catch((error) => error)
}

export function fetchRequestNewsViews() {

    const myHeaders = new Headers();

    const requestOptions = {
        method: "GET",
        headers: myHeaders,
    };

    return fetch(`https://feedback.sespel.su/article/views`, requestOptions)
        .then((response) => response.json())
        .then((result) => result)
        .catch((error) => error)
}

export function fetchRequestNewsViewsTitle(title) {

    const myHeaders = new Headers();

    const requestOptions = {
        method: "GET",
        headers: myHeaders,
    };

    return fetch(`https://feedback.sespel.su/article/views/single?article_title=${title}`, requestOptions)
        .then((response) => response.json())
        .then((result) => result)
        .catch((error) => error)


}